<template>
  <div>
    <v-dialog v-model="dialog" max-width="70%" persistent>
      <v-card>
        <v-card-title>
          <span>
              {{ getManufactureTitle() }}
             </span>
          <v-spacer></v-spacer>

          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="mr-2" @click="showEventDialog">
                history
              </v-icon>
            </template>
            <span>Thông tin lịch sử</span>
          </v-tooltip>

          <v-icon @click="closeDialog">close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container align="center">
            <v-row align="start">
              <v-col cols="12" sm="7">
                <v-row class="font-weight-black"> {{ $t('manufacture_dialog.saler') }}</v-row>
                <v-row class="pb-1"> {{ $t('detail_request.fullname') }} {{ editedSale.fullname }}</v-row>
                <v-row class="pb-1"> {{ $t('detail_request.nickname') }} {{ editedSale.nickname }}</v-row>
                <v-row class="pb-4"> {{ $t('detail_request.phone') }} {{ editedSale.phone }}</v-row>

                <v-row class="font-weight-black"> {{ $t('manufacture_dialog.designer') }}</v-row>
                <v-row class="pb-1"> {{ $t('detail_request.fullname') }} {{ editedDesigner.fullname }}</v-row>
                <v-row class="pb-1"> {{ $t('detail_request.nickname') }} {{ editedDesigner.nickname }}</v-row>
                <v-row class="pb-4"> {{ $t('detail_request.phone') }} {{ editedDesigner.phone }}</v-row>

                <v-row class="font-weight-black">
                  <span> {{ $t('detail_request.customer_infor') }} </span>
                  <!-- <v-icon class="pb-2" @click="editCustomer"> edit </v-icon> -->
                </v-row>
                <v-row class="pb-1"> {{ $t('detail_request.fullname') }}
                  {{ editedCustomer.defaultAddress ? editedCustomer.defaultAddress.name : editedCustomer.fullname }}
                </v-row>
                <v-row class="pb-1"> {{ $t('detail_request.phone') }}
                  {{ editedCustomer.defaultAddress ? editedCustomer.defaultAddress.phone : editedCustomer.phone }}
                </v-row>

                <v-row class="pb-1"> {{ $t('detail_request.facebook') }} <a :href="editedCustomer.facebook"
                                                                            target="_blank">
                  {{ editedCustomer.facebook ? editedCustomer.facebook : '' }} </a></v-row>

                <v-row class="pb-1"> {{ $t('detail_request.address') }} {{
                    addressToString(defaultEditAddress)
                  }}
                </v-row>

                <v-row class="pb-4"> {{ $t('detail_request.customer_type') }} {{ editedCustomerType.name }}</v-row>

                <v-row class="font-weight-black">
                  <span> {{ $t('detail_request.ship_infor') }} </span>
                  <!-- <v-icon class="pb-2" @click="editCustomer"> edit </v-icon> -->
                </v-row>
                <v-row class="pb-1"> {{ $t('manufacture_dialog.deadline') }} {{
                    editedItem.deadline | formateDate
                  }}
                </v-row>
                <v-row class="pb-1"> {{ $t('manufacture_dialog.receive_date') }} {{
                    editedItem.receiveDate | formateDate
                  }}
                </v-row>

                <v-row class="pb-1"> {{ $t('manufacture_dialog.receive_time') }} {{ editedItem.receiveTime }}</v-row>
                <v-row class="pb-1"> {{ $t('manufacture_dialog.number_of_product_received') }}
                  {{ editedItem.numberOfProductReceived ? editedItem.numberOfProductReceived : 'Chưa nhận áo.' }}
                </v-row>

                <v-row class="pb-1"> {{ $t('manufacture_dialog.logistic_unit') }}
                  {{ editedItem.logisticUnit ? editedItem.logisticUnit.name : $t('common.not_yet') }}
                </v-row>
                <v-row class="pb-1"> {{ $t('manufacture_dialog.ship_code') }}
                  {{ editedItem.shipCode ? editedItem.shipCode : $t('common.not_yet') }}
                </v-row>

                <v-row class="pb-1"> {{ $t('manufacture_dialog.ship_type') }}
                  {{ generateTextByShipType(editedItem.shipType) }}
                </v-row>

                <v-row class="pb-1"> {{ $t('manufacture_dialog.payment_method') }}
                  {{ generateTextByPaymentMethod(editedItem.paymentMethod) }}
                </v-row>
                <v-row class="pb-4"> {{ $t('detail_request.ship_note') }} {{ editedItem.shipNote }}</v-row>

                <v-row class="font-weight-black">
                  <span> {{ $t('manufacture_dialog.financial') }} <v-icon class="pb-2" @click="showEditFinance"
                                                                          v-show="editable"> edit </v-icon> </span>
                </v-row>
                <v-row class="pb-1">
                  <span> {{ $t('manufacture_dialog.subtotal') }} <span
                      class="totalFont">{{ thousandSeprator(editedItem.subTotal) }}</span>đ </span>
                </v-row>
                <v-row class="pb-1">
                  <span> {{ $t('manufacture_dialog.discount') }} <span class="totalFont">{{
                      thousandSeprator(editedItem.discount ? editedItem.discount : 0)
                    }}</span>đ </span>
                </v-row>
                <v-row class="pb-1">
                  <span> {{ $t('manufacture_dialog.addition_cost') }} <span class="totalFont">{{
                      thousandSeprator(editedItem.additionCost ? editedItem.additionCost : 0)
                    }}</span>đ </span>
                </v-row>
                <v-row class="pb-2">
                  <span> {{ $t('manufacture_dialog.vat') }} <span
                      class="totalFont">{{ editedItem.vat ? editedItem.vat : 0 }}</span>% </span>
                </v-row>
                <v-row class="pb-4">
                  <span>{{ $t('manufacture_dialog.total') }}<span
                      class="totalFont">{{ thousandSeprator(editedItem.total) }}</span>đ </span>
                </v-row>

                <v-row class="pb-1">
                  <span> {{ $t('manufacture_dialog.prepay') }} <span class="totalFont">{{
                      thousandSeprator(editedItem.prepay ? editedItem.prepay : 0)
                    }}</span>đ </span>
                </v-row>
                <v-row class="pb-2">
                  <span>{{ $t('manufacture_dialog.final_total') }}<span
                      class="totalFont">{{ thousandSeprator(calculateMoneyHasToPay(editedItem)) }}</span>đ </span>
                </v-row>

                <v-row class="pb-2">
                  <span> {{ $t('manufacture_dialog.money_charge') }} <span
                      class="totalFont">{{ thousandSeprator(editedItem.totalEdit ? editedItem.totalEdit : 0) }}</span>đ </span>
                </v-row>

                <v-row class="pb-4">
                  {{ $t('manufacture_dialog.file_pay') }}
                  <v-col cols="12" sm="11">
                                    <span v-for="file in editedItem.proofImgs" :key="file._id"> 
                                        - <a :href="baseAttach + file._id" target="_blank">
                                        {{ file.filename }}
                                        </a> <br/>
                                    </span>
                  </v-col>
                </v-row>

                <v-row class="font-weight-black">
                  <span> {{ $t('manufacture_dialog.list_production') }} <v-icon class="pb-2" @click="showEditProduct"
                                                                                v-show="editable"> edit </v-icon> </span>
                </v-row>
                <v-row> {{ $t('manufacture_dialog.total_product') }}
                  {{ thousandSeprator(calculateTotalSizeOfAll(editedItem)) }} chiếc
                </v-row>
                <v-row v-for="(detail, index) in editedItem.request_details" :key="detail._id">
                  <v-col cols="12" sm="1">
                    {{ index + 1 }}.
                  </v-col>
                  <v-col cols="12" sm="11">
                    {{ $t('manufacture_dialog.form_style') }} {{ detail.formStyle.name }} <br/>
                    {{ $t('manufacture_dialog.material_style') }} {{ createMaterialStyleString(detail) }} <br/>
                    {{ $t('manufacture_dialog.number') }} {{ thousandSeprator(calculateTotalSizeOfProduct(detail)) }}
                    chiếc<br/>
                    {{ $t('manufacture_dialog.gift_number') }} {{ thousandSeprator(detail.giftNumber) }} chiếc<br/>

                    <span v-for="profile in detail.profilesInfo" :key="profile._id">
                                        - {{ generateProfileSizes(profile) }} <br/>
                                    </span>
                    <span> {{ $t('manufacture_dialog.price') }} <span
                        class="numberFont">{{ thousandSeprator(detail.price) }}</span>đ / sản phẩm </span> <br/>
                    <span> {{ $t('manufacture_dialog.total_money_product') }} <span class="numberFont">{{
                        thousandSeprator(calculateTotalMoneyOfProduct(detail))
                      }}</span>đ </span><br/>
                    {{ $t('manufacture_dialog.tailor_note') }} {{ detail.tailorNote }}<br/>
                    {{ $t('manufacture_dialog.print_note') }} {{ detail.printNote }}<br/>
                    {{ $t('manufacture_dialog.finance_note') }} {{ detail.financeNote }}<br/>

                    {{ $t('manufacture_dialog.file_attach') }} <br/>
                    <span v-for="file in detail.files" :key="file._id">
                                        - <a :href="baseAttach + file._id" target="_blank">
                                        {{ file.filename }}
                                        </a> <br/>
                                    </span>
                    <!-- <a v-for="file in detail.files" :key="file._id" :href="baseAttach + file._id" target="_blank">
                        - {{ file.filename }}
                    </a>  -->
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" sm="5">
                <v-card>
                  <v-card-title>{{ $t('manufacture_dialog.file_design') }}</v-card-title>
                  <v-card-text>
                    <v-container align="center">
                      <v-row align="start">
                        <v-col cols="12" sm="12" v-for="file in uploadedFiles" :key="file._id">
                          <a :href="baseAttach + file._id" target="_blank">
                            {{ file.filename }}
                          </a>
                        </v-col>

                        <v-col cols="12" sm="12" v-for="gFile in gDrive" :key="gFile._id">
                          <a :href="gFile.url" target="_blank">
                            {{ gFile.name }}
                          </a>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="markUnreadStatus" class="mr-5">
              {{ $t('common.mark_unread') }}
            </v-btn>

            <v-btn color="primary" @click="editManufactureRequest" width="120px" v-if="isViewSale">
              {{ $t('common.edit') }}
            </v-btn>
          </v-toolbar>
        </v-card-text>
      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogEditFinance" max-width="70%">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('tooltip_infor.financial') }}</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <v-container align="center">
            <v-row align="start">
              <v-col cols="12" sm="6">
                <v-col>
                  <v-numeric-field v-model="editedItem.subTotal" v-bind:label="$t('manufacture_item.total_cost')"
                                   outlined readonly>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>{{ $t('tooltip_infor.total_money') }}</span>
                    </v-tooltip>
                  </v-numeric-field>
                </v-col>
                <v-col>
                  <v-numeric-field v-model="discount" v-bind:label="$t('manufacture_item.discount')" outlined>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>{{ $t('tooltip_infor.discount_money') }}</span>
                    </v-tooltip>
                  </v-numeric-field>
                </v-col>

                <v-col>
                  <v-textarea v-model="editedItem.discountNote" v-bind:label="$t('manufacture_item.note_discount')"
                              outlined>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>{{ $t('tooltip_infor.discount_note') }}</span>
                    </v-tooltip>
                  </v-textarea>
                </v-col>

                <v-col>
                  <v-numeric-field v-model="vat" v-bind:label="$t('manufacture_item.vat')" outlined>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>{{ $t('tooltip_infor.vat') }}</span>
                    </v-tooltip>
                  </v-numeric-field>
                </v-col>

              </v-col>

              <v-col cols="12" sm="6">
                <v-col>
                  <v-numeric-field v-model="prepay" v-bind:label="$t('manufacture_item.prepay')" outlined>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>{{ $t('tooltip_infor.prepay') }}</span>
                    </v-tooltip>
                  </v-numeric-field>
                </v-col>

                <v-col>
                  <v-numeric-field v-model="additionCost" v-bind:label="$t('manufacture_item.addition_cost')" outlined>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>{{ $t('tooltip_infor.addition_cost') }}</span>
                    </v-tooltip>
                  </v-numeric-field>
                </v-col>

                <v-col>
                  <v-textarea v-model="editedItem.additionCostNote" v-bind:label="$t('manufacture_item.note_addtion')"
                              outlined>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>{{ $t('tooltip_infor.addition_note') }}</span>
                    </v-tooltip>
                  </v-textarea>
                </v-col>

                <v-col>
                  <v-numeric-field v-model="finalPrice" v-bind:label="$t('manufacture_item.final_cost')" outlined
                                   readonly>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>{{ $t('tooltip_infor.finally_money') }}</span>
                    </v-tooltip>
                  </v-numeric-field>
                </v-col>
              </v-col>
            </v-row>
          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-btn color="primary" @click="closeEditFinance" width="120px" class="mr-5">
              {{ $t('common.cancel') }}
            </v-btn>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="checkInforFinance" width="120px" class="mr-5">
              {{ $t('common.done') }}
            </v-btn>
          </v-toolbar>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEditProduct" max-width="70%">
      <v-card>
        <v-card-title>
          <span class="headline">Thông tin sản xuất</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <v-container align="center">
            <v-row align="center" justify="center">
              <v-col v-for="detail in detailProfiles" :key="detail._id" cols="12">
                <v-card>
                  <v-card-title v-text="createHeaderStyle(detail)"></v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-row v-for="(item, index) in detail.profilesInfo" :key="item._id">
                            <v-col cols="12">
                              <span> {{
                                  (index + 1) + '. ' + item.profile.name + '(' + calculateProfile(item.sizes) + 'chiếc): '
                                }}</span>
                            </v-col>
                            <v-col cols="12" md="2" v-for="size in getAvailableSize(item.sizes)" :key="size._id">
                              <v-numeric-field v-model="size.number" v-bind:label="getSizeName(size)" outlined
                                               disabled></v-numeric-field>
                            </v-col>
                          </v-row>
                        </v-col>

                        <v-col cols="12" md="4">
                          <span> Đơn giá: <span class="totalFont"> {{ thousandSeprator(detail.price) }} </span>đ / sản phẩm</span>
                          <br/>

                          <span> Số lượng: <span class="totalFont"> {{
                              thousandSeprator(calculateTotalSizeOfProduct(detail))
                            }} </span> </span>
                          <br/>

                          <span> Áo tặng: <span class="totalFont"> {{
                              thousandSeprator(detail.giftNumber)
                            }} </span></span>
                        </v-col>

                        <v-col cols="12" md="2">
                          <span class="totalFont">{{ thousandSeprator(calculateTotalMoneyOfProduct(detail)) }} đ</span>
                        </v-col>
                      </v-row>

                    </v-container>

                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-btn icon>
                          <v-icon v-on="on" @click="editProductInfor(detail)">edit</v-icon>
                        </v-btn>
                      </template>
                      <span>Chỉnh sửa thông tin sản phẩm</span>
                    </v-tooltip>

                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-btn icon>
                          <v-icon v-on="on" @click="deleteProductInfor(detail)">mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Xóa sản phẩm</span>
                    </v-tooltip>
                  </v-card-actions>
                </v-card>
              </v-col>

              <v-col>
                <v-divider></v-divider>

                <v-row class="pt-4 pr-4">
                  <v-spacer></v-spacer>
                  <span> Tổng tiền: <span class="totalFont"> {{
                      thousandSeprator(editedItem.subTotal)
                    }} </span> đ</span>
                </v-row>
              </v-col>
            </v-row>
          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-btn color="primary" @click="closeEditProduct" width="120px" class="mr-5">
              {{ $t('common.cancel') }}
            </v-btn>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="checkAddProductionInfor" width="120px" class="mr-5">
              {{ $t('common.done') }}
            </v-btn>
          </v-toolbar>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAddStyleProfile" persistent max-width="70%">
      <v-stepper v-model="e3">
        <v-stepper-header>
          <v-stepper-step :complete="e3 > 1" step="1">Nhập thông tin sản phẩm</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="e3 > 2" step="2">Nhập số lượng</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-container v-if="e3 === 1">
              <v-row>
                <v-col cols="12" sm="6">
                  <v-autocomplete v-model="selectFormStyle" :items="formStyles" item-text="name"
                                  v-bind:label="$t('manufacture_item.form_style')" outlined return-object>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>Chọn kiểu áo để thiết kế và sản xuất</span>
                    </v-tooltip>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-autocomplete v-model="selectMaterial" :items="materialStyles" item-text="displayString"
                                  v-bind:label="$t('manufacture_item.material_style')" outlined return-object>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>Chọn nguyên vật liệu để sản xuất áo</span>
                    </v-tooltip>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6">
                  <!-- <v-text-field v-model="editedDetailProfile.price" type="number" :rules="numberRules" v-bind:label="$t('manufacture_item.cost')" outlined min="0"></v-text-field> -->
                  <v-numeric-field v-model="editedDetailProfile.price" v-bind:label="$t('manufacture_item.cost')"
                                   outlined>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>Nhập giá cho sản phẩm</span>
                    </v-tooltip>
                  </v-numeric-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-numeric-field v-model="editedDetailProfile.giftNumber"
                                   v-bind:label="$t('manufacture_item.number_shirt')" outlined>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>Nhập số lượng áo tặng</span>
                    </v-tooltip>
                  </v-numeric-field>
                </v-col>

                <v-col cols="12" sm="12">
                  <v-textarea v-model="editedDetailProfile.note" v-bind:label="$t('design_item.note')" outlined>
                    <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">info</v-icon>
                      </template>
                      <span>Nhập ghi chú sản xuất cho sản phẩm</span>
                    </v-tooltip>
                  </v-textarea>
                </v-col>

                <v-col cols="12" sm="6">
                  {{ $t('common.attach_file') }}
                  <v-row v-for="file in uploadedFiles" :key="file._id">
                    <v-col cols="12" sm="6">
                      <a :href="baseAttach + file._id" target="_blank">
                        {{ file.filename }}
                      </a>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>

            <!-- <v-btn color="primary" @click="createUser" width="120px" class="mr-5">
                {{ $t('common.continue') }}
            </v-btn>

            <v-btn color="primary" width="120px" @click="closeAddCustomer">{{ $t('common.cancel') }}</v-btn> -->

            <v-divider></v-divider>
            <v-toolbar flat>
              <v-btn color="primary" width="120px" @click="closeEditProfileInfor">{{ $t('common.cancel') }}</v-btn>

              <v-spacer></v-spacer>

              <v-btn color="primary" @click="checkInforProduct" class="mr-5">
                {{ $t('common.continue') }}
              </v-btn>
            </v-toolbar>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-container align="center" v-if="e3 === 2">
              <v-row v-for="item in profiles" :key="item._id">
                <v-col cols="12">
                  <span> {{ item.profile ? item.profile.name : 'NA' }} {{ ': ' + calculateProfile(item.sizes) }}</span>
                </v-col>

                <v-col cols="12" sm="2" v-for="size in item.sizes" :key="size._id">
                  <v-numeric-field v-model="size.number" v-bind:label="getSizeName(size)" outlined>
                  </v-numeric-field>
                </v-col>
              </v-row>

              <v-divider></v-divider>
              <v-row>
                <v-col cols="12">
                  <span> Tổng số {{ ': ' + calculateTotalSizeOfAllProfiles(profiles) }}</span>
                </v-col>

              </v-row>
            </v-container>

            <v-divider></v-divider>
            <v-toolbar flat>
              <v-btn color="primary" width="120px" @click="backAddSizeProfile">{{ $t('common.back') }}</v-btn>

              <v-spacer></v-spacer>

              <v-btn color="primary" width="120px" @click="addProduct">{{ $t('common.done') }}</v-btn>
            </v-toolbar>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>

    </v-dialog>

    <event-log v-model="eventDialog" :editedItem="editedItem" :type="2" @closeDialog="closeEventDialog"
               v-if="editedItem">
    </event-log>

  </div>
</template>

<script>
import i18n from '@/plugins/i18n';
import moment from 'moment';
import VNumericField from "@/components/VNumericField";
import EventLog from "@/components/EventLog";

export default {
  name: 'manufacture-request-dialog',

  components: {
    VNumericField: VNumericField,
    EventLog: EventLog
  },

  data: () => ({
    baseImage: process.env.VUE_APP_BASE_IMAGE,
    baseAttach: process.env.VUE_APP_BASE_ATTACH,

    e3: 1,
    dialogDetail: false,
    designRequest: {},

    // editedItem: {},
    editedCustomer: {},
    defaultEditAddress: {},
    editedCustomerType: {},
    editedSale: {},
    editedDesigner: {},
    defaultItem: {},

    stringRules: [
      v => !!v || i18n.t('validate.not_empty'),
      v => (v && v.length > 2) || i18n.t('validate.string_invalid')
    ],

    discount: 0,
    additionCost: 0,
    prepay: 0,
    vat: 0,

    finalPrice: 0,

    detailProfiles: [],

    files: [],
    uploadedFiles: [],
    gDrive: [],

    dialogEditFinance: false,
    dialog: false,

    dialogEditProduct: false,
    dialogAddStyleProfile: false,

    selectFormStyle: '',
    formStyles: [],

    selectMaterial: '',
    materialStyles: [],

    editedDetailProfile: {},
    profiles: [],

    eventDialog: false
  }),

  props: {
    // Use "value" to enable using v-model
    value: Boolean,
    editedItem: Object,
    editable: Boolean,
    isViewSale: Boolean
  },

  watch: {
    discount(val) {
      if (val >= 0) {
        this.editedItem.discount = val;
        this.calculateFinalTotal();
      } else {
        this.discount = 0;
      }
    },

    additionCost(val) {
      if (val >= 0) {
        this.editedItem.additionCost = val;
        this.calculateFinalTotal();
      } else {
        this.additionCost = 0;
      }
    },

    prepay(val) {
      if (val >= 0) {
        this.editedItem.prepay = val;
        // this.calculateFinalTotal();
      } else {
        this.additionCost = 0;
      }
    },

    vat(val) {
      if (val >= 0) {
        this.editedItem.vat = val;
        this.calculateFinalTotal();
      } else {
        this.additionCost = 0;
      }
    },
  },

  created() {
    this.getAllFormStyles();
    this.getMaterialStyles();
    this.dialog = this.value;
    this.getData(this.editedItem);

    this.updateStatus(1);
  },

  methods: {
    getData(item) {
      this.editedCustomer = Object.assign({}, this.editedItem.customer)
      this.date = moment(String(this.editedCustomer.birthday)).format("YYYY-MM-DD");

      this.defaultEditAddress = this.editedCustomer.defaultAddress;

      this.editedSale = Object.assign({}, this.editedItem.sale)
      this.editedDesigner = Object.assign({}, this.editedItem.designer)
      this.selectOrderType = this.editedItem.orderType;
      this.editedCustomerType = this.editedItem.customerType;

      this.designRequest = item.designRequest;

      this.front_printStyle = item.front_printStyle;
      this.behind_printStyle = item.behind_printStyle;
      this.arm_printStyle = item.arm_printStyle;
      this.uploadedFiles = item.files;
      this.gDrive = [].concat(item.gDrive);

      this.discount = this.editedItem.discount ? this.editedItem.discount : 0;
      this.additionCost = this.editedItem.additionCost ? this.editedItem.additionCost : 0;
      this.vat = this.editedItem.vat ? this.editedItem.vat : 0;
      this.prepay = this.editedItem.prepay ? this.editedItem.prepay : 0;
      this.finalPrice = this.editedItem.total;
      this.detailProfiles = [].concat(this.editedItem.request_details);
    },

    getManufactureTitle() {
      return this.$getManufactureTitle(this.editedItem);
    },

    generateTextByShipType(shipType) {
      if (shipType === 1) {
        return 'Chuyển phát nhanh miền Bắc';
      } else if (shipType === 2) {
        return 'Chuyển phát nhanh miền Trung, Nam';
      } else if (shipType === 3) {
        return 'Hỏa tốc miền Trung, Nam';
      } else {
        return '';
      }
    },
    addressToString(detail) {
      if (detail && detail.fullDetail) {
        return detail.fullDetail;
      } else {
        return '';
      }
    },

    thousandSeprator(amount) {
      if (amount && (amount !== '' || amount !== 0 || amount !== '0')) {
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else {
        return 0;
      }
    },

    calculateMoneyHasToPay(editedItem) {
      const prepay = editedItem.prepay ? editedItem.prepay : 0;
      return editedItem.total - prepay;
    },

    calculateTotalSizeOfAll(detail) {
      let total = 0;
      if (detail.request_details) {
        detail.request_details.forEach(detail => {
          total = total + this.calculateTotalSizeOfProduct(detail);
        });
      }

      return total;
    },

    createMaterialStyleString(detail) {
      if (!detail.materialStyle) {
        return '--';
      }
      return detail.materialStyle.material.name + " - " + detail.materialStyle.color_name
    },

    calculateTotalSizeOfProduct(detail) {
      let total = 0;
      detail.profilesInfo.forEach(item => {
        total = total + this.calculateProfile(item.sizes);
      });

      return total;
    },

    calculateTotalMoneyOfProduct(detail) {
      return (this.calculateTotalSizeOfProduct(detail) - detail.giftNumber) * parseInt(detail.price, 10);
    },

    closeEditFinance() {
      this.dialogEditFinance = false;
    },

    showEditFinance() {
      this.dialogEditFinance = true;
    },

    showEventDialog() {
      this.eventDialog = true;
    },

    closeEventDialog(value) {
      this.eventDialog = value
    },

    checkInforFinance() {
      if (this.editedItem.discount && parseInt(this.editedItem.discount) < 0) {
        alert(i18n.t('validate.discount_invalid'));
        return;
      }

      if (this.editedItem.additionCost && parseInt(this.editedItem.additionCost) < 0) {
        alert(i18n.t('validate.addition_invalid'));
        return;
      }


      if ((!this.editedItem.discountNote || this.editedItem.discountNote.length == 0) && parseInt(this.editedItem.discount) > 0) {
        alert(i18n.t('validate.discount_note_empty'));
        return;
      }

      if ((!this.editedItem.additionCostNote || this.editedItem.additionCostNote.length == 0) && parseInt(this.editedItem.additionCost) > 0) {
        alert(i18n.t('validate.addition_note_empty'));
        return;
      }

      if (this.editedItem.total && parseInt(this.editedItem.total) < 0) {
        alert(i18n.t('validate.finaly_invalid'));
        return;
      }

      if (this.editedItem.prepay && parseInt(this.editedItem.prepay) < 0) {
        alert(i18n.t('validate.prepay_invalid'));
        return;
      }

      this.updateManufactureRequest();
    },

    closeEditProduct() {
      this.dialogEditProduct = false;
    },

    showEditProduct() {
      this.dialogEditProduct = true;
    },

    checkAddProductionInfor() {
      if (!this.detailProfiles || this.detailProfiles.length == 0) {
        alert('Chưa thêm thông tin sản phẩm');
        return;
      }

      this.updateManufactureRequest();
    },

    editProductInfor(detail) {
      this.uploadedFiles = [];

      this.editedProductIndex = this.detailProfiles.indexOf(detail);
      this.editedDetailProfile = detail;
      this.selectProfile = detail.profile;
      this.profiles = detail.profilesInfo;

      detail.materialStyle.displayString = this.createMaterialStyleStringDefault(detail.materialStyle);

      this.selectMaterial = detail.materialStyle;
      this.selectFormStyle = detail.formStyle;

      this.uploadedFiles = this.editedDetailProfile.files;
      this.dialogAddStyleProfile = true;
    },

    closeEditProfileInfor() {
      this.uploadedFiles = [];
      this.dialogAddStyleProfile = false;
      this.e3 = 1;
    },

    calculateProfile(sizes) {
      let total = 0;
      sizes.forEach(size => {
        if (!size.number) {
          size.number = 0;
        } else {
          total = total + parseInt(size.number, 10);
        }
      });

      return total;
    },

    generateProfileSizes(profile) {
      let data = '';

      profile.sizes.forEach(item => {
        if (item.number > 0) {
          data = data + item.number + '-' + item.size.name + '; ';
        }
      });

      return profile.profile.name + '(' + this.calculateProfile(profile.sizes) + ' chiếc): ' + data;
    },

    createHeaderStyle(detail) {
      return detail.formStyle.name + " - " + detail.materialStyle.material.name + " - " + detail.materialStyle.color_name;
    },

    getAvailableSize(sizes) {
      return sizes.filter(item => item.number > 0);
    },

    getSizeName(detail) {
      if (detail.size) {
        return detail.size.name
      }
    },

    calculateFinalTotal() {
      const totalVAT = this.editedItem.subTotal + parseInt(this.additionCost) - parseInt(this.discount);
      this.finalPrice = totalVAT + parseInt(totalVAT * this.vat / 100);
      this.editedItem.total = this.finalPrice;
    },

    async updateManufactureRequest() {
      let requestBody = Object.assign({}, this.editedItem);

      requestBody = {
        ...requestBody,
        customer: this.editedCustomer._id,
        orderType: this.selectOrderType._id,
        customerType: this.editedCustomerType,
        deadline: moment(String(this.editedItem.deadline)).format("DD/MM/YYYY"),
        receiveDate: moment(String(this.editedItem.receiveDate)).format("DD/MM/YYYY"),
        request_details: this.detailProfiles
      }
      if (this.editedItem.requestMethod !== 2) {
        requestBody.designRequest = this.designRequest._id;
        requestBody.designer = this.editedDesigner._id;
      }

      const response = await this.$http.put('/manufactureRequest/' + this.editedItem._id, requestBody);
      if (response.data && response.data.success) {
        this.$fire({
          title: i18n.t('common.update_success'),
          text: "",
          type: "success"
        }).then(() => {
          // Object.assign(this.desserts[this.editedIndex], this.editedItem);
          this.$emit('update', this.editedItem);
          if (this.dialogEditFinance) {
            this.closeEditFinance();
          } else if (this.dialogEditProduct) {
            this.closeEditProduct();
          }
        });
      } else if (response.data && !response.data.success) {
        alert(response.data.message);
      } else {
        alert(i18n.t('validate.request_error'));
      }
    },

    async getAllFormStyles() {
      try {
        const response = await this.$http.get('/formStyle');
        if (response.data && response.data.success) {
          const contextArr = response.data.data;
          this.formStyles = contextArr;

          if (this.formStyles.length > 0) {
            this.selectFormStyle = this.formStyles[0];
          }
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async getMaterialStyles() {
      try {
        const response = await this.$http.get('/materialStyle');
        if (response.data && response.data.success) {
          const contextArr = response.data.data;
          this.materialStyles = contextArr;

          if (this.materialStyles.length > 0) {
            this.materialStyles.forEach(item => {
              item.displayString = this.createMaterialStyleStringDefault(item);
            });

            this.selectMaterial = this.materialStyles[0];
          }
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    calculateTotalSizeOfAllProfiles(profiles) {
      let total = 0;
      profiles.forEach(item => {
        total = total + this.calculateProfile(item.sizes);
      });

      return total;
    },

    checkInforProduct() {
      if (!this.uploadedFiles || this.uploadedFiles.length == 0) {
        alert("Chưa đính kèm file minh họa");
        return;
      }

      if (!this.editedDetailProfile.price || this.editedDetailProfile.price <= 0) {
        alert("Chưa nhập đơn giá hoặc đơn giá sai định dạng!");
        return;
      }

      this.editedDetailProfile.formStyle = this.selectFormStyle;
      this.editedDetailProfile.materialStyle = this.selectMaterial;
      this.editedDetailProfile.files = [].concat(this.uploadedFiles);


      this.e3 = 2;
    },

    backAddSizeProfile() {
      if (this.e3 > 1) {
        this.e3 = this.e3 - 1;
      }
    },

    addProduct() {
      this.editedDetailProfile.profilesInfo = this.profiles;

      if (this.calculateTotalSizeOfProduct(this.editedDetailProfile) == 0) {
        alert("Chưa nhập số lượng!");
        return;
      }

      this.calculateTotalMoneyOfAll();

      Object.assign(this.detailProfiles[this.editedIndex], this.editedDetailProfile);
      this.editedDetailProfile = {};
      this.e3 = 1;
      this.dialogAddStyleProfile = false;
    },

    createMaterialStyleStringDefault(detail) {
      if (!detail) {
        return '--';
      }
      return detail.code + ' (' + detail.material.name + " - " + detail.color_name + ')';
    },

    closeDialog() {
      this.dialog = false;
      this.$emit('closeDialog', this.dialog);
    },

    editManufactureRequest() {
      this.$router.push({
        name: "createManufactureRequest",
        params: {editedTarget: 1, editedManufacture: this.editedItem}
      });
    },

    generateTextByPaymentMethod(value) {
      if (value == 2) {
        return 'Sale tự thu tiền';
      } else {
        return 'Thu tiền qua hệ thống ship';
      }
    },

    markUnreadStatus() {
      this.updateStatus(0);
      this.closeDialog();
    },

    async updateStatus(status) {
      const userType = localStorage.getItem('type');
      let requestBody = {};
      if (userType == 1 && this.editedItem.saleReadStatus != status) {
        requestBody.saleReadStatus = status;
        const isSuccess = await this.$updateManufactureRequestByUser(this.editedItem._id, requestBody);

        if (isSuccess) {
          this.editedItem.saleReadStatus = status;
          this.$emit('update', this.editedItem);
        }
      } else if (userType == 2 && this.editedItem.designerReadStatus != status) {
        requestBody.designerReadStatus = status;
        const isSuccess = await this.$updateManufactureRequestByUser(this.editedItem._id, requestBody);

        if (isSuccess) {
          this.editedItem.designerReadStatus = status;
          this.$emit('update', this.editedItem);
        }
      } else if (userType == 3 && this.editedItem.accountantReadStatus != status) {
        requestBody.accountantReadStatus = status;
        const isSuccess = await this.$updateManufactureRequestByUser(this.editedItem._id, requestBody);

        if (isSuccess) {
          this.editedItem.accountantReadStatus = status;
          this.$emit('update', this.editedItem);
        }
      } else if (userType == 4 && this.editedItem.shipReadStatus != status) {
        requestBody.shipReadStatus = status;
        const isSuccess = await this.$updateManufactureRequestByUser(this.editedItem._id, requestBody);

        if (isSuccess) {
          this.editedItem.shipReadStatus = status;
          this.$emit('update', this.editedItem);
        }
      }
    }
  }
}
</script>
